<template>
  <div class="content">
    <div class="title-file">文件上传</div>
    <!--    <van-uploader :after-read="afterRead" :before-delete="deleteHX" preview-image v-model="fileList" :max-count="1" />-->
    <div v-for="(el, index) in useList" :key="index">
      <div class="up-title" style="text-align: center;">{{ el.adminTitle }}</div>
      <div v-for="(item, idx) in el.list" :key="idx">
        <div class="up-title">{{ item.title }}</div>
        <van-uploader :after-read="(file) => afterRead(file, item, el.adminTitle)"
          :before-delete="(file, detail) => deleteJK(file, detail, item.filelist, item.files)" multiple preview-image
          v-model="item.filelist" accept="file" />
      </div>
    </div>
    <div class="red">
      上传完成后请在终端刷新文件列表
    </div>
    <div style="height: 10vh;"></div>
  </div>
</template>

<script>
// import { ref, onMounted, getCurrentInstance } from 'vue'
// import { useRoute } from 'vue-router'
import { Dialog, Toast } from "vant";
export default {
  name: '',
  data() {
    return {
      uuid: '',
      // title: '',
      // type: null,
      // 预览列表
      // fileListJK: [],
      useList: [],
      firmList: [
        {
          adminTitle: "",
          list: [
            {
              title: '法定代表人身份证件复、影印件',
              filelist: [],
              files: []
            },
            {
              title: '董事、监事、经理身份证件复、影印件',
              filelist: [],
              files: []
            },
            {
              title: '联络员身份证件复、影印件',
              filelist: [],
              files: []
            },
            {
              title: '指定代表/委托代理人身份证件复、影印件',
              filelist: [],
              files: []
            },
          ]
        }
      ],
      classfileList: [
        {
          id: 0,
          adminTitle: "",
          list: [
            {
              title: '申请表',
              filelist: [],
              files: []
            },
            {
              title: '承诺书',
              filelist: [],
              files: []
            },
            {
              title: '经营场所、库房地址的地理位置图、平面图、设备设施布局图',
              filelist: [],
              files: []
            },
            {
              title: '房屋租赁协议或产权证明文件',
              filelist: [],
              files: []
            },
          ]
        },
        {
          id: 1,
          adminTitle: "食品经营",
          list: [
            {
              title: '食品安全管理人员任命书（个体工商户不需要）',
              filelist: [],
              files: []
            },
            {
              title: '与食品经营相适应的操作流程文件',
              filelist: [],
              files: []
            },
            {
              title: '从业人员名单及健康检查和食品安全及卫生知识培训考核资料',
              filelist: [],
              files: []
            },
            {
              title: '食品安全自查、从业人员健康管理、进货查验记录、食品安全事故处置等保证食品安全的规章制度',
              filelist: [],
              files: []
            },
            {
              title: '直接接触食品的设备或设施、工具、容器，包装材料等产品合格证明材料',
              filelist: [],
              files: []
            },
            {
              title: '提交与挂钩生产单位的合作协议（合同），提交生产单位的《食品生产许可证》等证明材料（销售其他单位的散装类熟食）',
              filelist: [],
              files: []
            },
            {
              title: '提供经营过程中由总部统一保存的进货查验记录等材料目录（连锁经营食品）',
              filelist: [],
              files: []
            },
            {
              title: '具有可现场登录申请人网站、网页或网店等功能的设施设备（网络经营食品）',
              filelist: [],
              files: []
            },
            {
              title: '提供成品安全性检验合格报告（餐饮服务中提供自酿酒的）',
              filelist: [],
              files: []
            },
            {
              title: '制定食品添加剂使用、公示制度。（有添加剂的）',
              filelist: [],
              files: []
            },
          ]
        },
        {
          id: 2,
        },
        {
          id: 3,
          adminTitle: "公共场所卫生许可",
          list: [
            {
              title: '公共场所卫生行政许可承诺书',
              filelist: [],
              files: []
            }
          ]
        },
        {
          id: 4,
          adminTitle: "道路货物运输经营许可",
          list: [
            {
              title: '现有机动车辆行驶证、车辆技术等级证书或车辆技术检测合格证复印件，拟购置运输车辆的承诺书、行驶证、营运证、车辆技术等级证书、车辆技术检测合格证复印件、购买合同；',
              filelist: [],
              files: []
            },
            {
              title: '已聘用或拟聘用驾驶员的机动车驾驶证、从业资格证及其复印件；',
              filelist: [],
              files: []
            },
            {
              title: '安全生产管理制度文本。',
              filelist: [],
              files: []
            }
          ]
        },
        {
          id: 5,
          adminTitle: "出版物零售业务经营许可",
          list: [
            {
              title: '进货清单、进货方的出版物经营许可证（需加盖进货方的红章）',
              filelist: [],
              files: []
            },
            {
              title: '网络平台开具的证明（网络平台出具）；',
              filelist: [],
              files: []
            },
            {
              title: '发行单位网络备案表',
              filelist: [],
              files: []
            },
          ]
        },
        {
          id: 6,
          adminTitle: "户外招牌设置",
          list: [
            {
              title: '您预设置的招牌设置前位置图(照片应能体现左邻右舍对比，如无左邻右舍可单独)',
              filelist: [],
              files: []
            },
            {
              title: '您预设置的招牌白天效果图(照片应能体现左邻右舍对比，如无左邻右舍可单独)',
              filelist: [],
              files: []
            },
            {
              title: '您预设置的招牌夜间效果图(照片应能体现左邻右舍对比，如无左邻右舍可单独)',
              filelist: [],
              files: []
            },
            {
              title: '您的身份证照片',
              filelist: [],
              files: []
            },
            {
              title: '您的营业执照（著名商标准许使用）照片(如系著名商标须提供著名商标允许使用证明文件)',
              filelist: [],
              files: []
            },
            {
              title: '您的房屋产权或者租房合同照片(此应该与营业执照地址一致)',
              filelist: [],
              files: []
            }
            // {
            //   title: '建筑物（场地）权属单位主体资格文件（营业执照、事业单位法人证书、不动产权证书等）复印件',
            //   filelist: [],
            //   files: []
            // },
            // {
            //   title: '原貌（现状）照片、效果图（白天、夜间各一份）',
            //   filelist: [],
            //   files: []
            // }
          ]
        },
        {
          id: 7,
          adminTitle: "创业担保贷款",
          list: [
            {
              title: '企业职工花名册',
              filelist: [],
              files: []
            },
            {
              title: '招用符合条件人员的人员类别证明，复员转业退役军人提供《自主择业军转干部证》《转业证》或《退伍证》，刑满释放人员提供《释放证明书》《假释证明书》或《刑满释放通知书》，高校毕业生提供《毕业证》，建档立卡贫困人口提供扶贫部门出具的精准识别卡',
              filelist: [],
              files: []
            },
            {
              title: '企业财务报表',
              filelist: [],
              files: []
            },
          ]
        },
      ],
    }
  },
  created() {
    this.uuid = this.$route.query.uuid
    this.useList = []
    var arr = []
    if (this.$route.query.common == '1') {
      this.useList.push(this.classfileList[0])
    }
    if (this.$route.query.type) {
      arr = this.$route.query.type.split(",")
    }
    arr.forEach(el => {
      this.useList.push(this.classfileList[Number(el)])
    })
    if (this.$route.query.cerno == '1') {
      this.useList.unshift(...this.firmList)
    }

    this.getInitList()
    // console.log(this.$doSm4('512921197006295917'));
    // console.log(this.$dptSm4('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'));


  },
  mounted() {
    var dom = document.querySelector('.tips-box');
    dom.style.display = "none"
    document.title = '文件上传';
  },
  methods: {
    getInitList() {
      this.$rqt.common_getRecord({
        key: this.uuid
        // key: '1234567'
      }).then(res => {
        if (res.data) {
          res.data[0].list.forEach(el => {
            if (el.filelist.length) {
              el.filelist[0].content = ''
              el.filelist[0].url = el.files[0].url
            }
          })
          var list = res.data
          this.useList = list
        }

      })
    },
    save() {
      this.useList[0].list.forEach(el => {
        if (el.filelist.length) {
          el.filelist[0].content = ''
          el.filelist[0].url = el.files[0].url
        }
      })
      this.$rqt.common_saveRecord({
        key: this.uuid,
        value: this.useList
      })
    },
    afterRead(file, item, title) {
      console.log(title);
      Toast.loading({
        message: '上传中...',
        forbidClick: true,
        duration: 0
      });
      // const formData = new FormData();
      var arr = Array.isArray(file)
      if (arr) {
        file.forEach(el => {
          const formData = new FormData();
          formData.append("file", el.file);
          this.startUpload(formData, item, title)
        });
      } else {
        const formData = new FormData();
        formData.append("file", file.file);
        this.startUpload(formData, item, title)
      }
    },
    startUpload(formData, item, title) {
      if (title == '户外招牌设置') {
        this.$rqt.shopSign_uploads(formData).then(res => {
          Toast.clear()
          item.files.push({
            name: item.title,
            url: res.file[0],
          })
          setTimeout(() => {
            this.save()
          }, 200);
        })
        return
      }
      this.$rqt.common_upload(formData).then(res => {
        Toast.clear()
        // console.log('上传完成', res);
        item.files.push({
          name: item.title,
          url: res.data,
        })
        setTimeout(() => {
          this.save()
        }, 200);
        // Dialog({
        // message: '请在终端点击刷新按钮',
        // });
      })
    },
    deleteJK(el, detail, vfile, files) {
      // console.log(el);
      // console.log(detail);
      // console.log(vfile);
      vfile.splice(detail.index, 1);
      files.splice(detail.index, 1);
      setTimeout(() => {
        this.save()
      }, 200);
      // Toast.loading({
      //   message: '删除中...',
      //   forbidClick: true,
      //   duration: 0
      // });
      // if (detail.index >= el.length) {
      //   return false
      // }
      // //加等待提示
      // // proxy.$axios.post("/enjoy/pass/industryFile/delfile?id=" + el.fid,).then(res => {
      // this.$rqt.common_delfile(el.fid).then(res => {
      //   console.log(res);
      //   if (res.code === 200) {
      //     vfile.splice(detail.index, 1);
      //     Toast.clear()
      //     Toast.success('删除成功')
      //     //取消等待提示
      //     return true
      //   } else {
      //     //取消等待提示
      //     //换成失败提示↓
      //     Toast.fail(res.msg);
      //     return false
      //   }
      // })
    }
  }
};
</script>
<style scoped lang="scss">
.content {
  padding: 10px;
  width: calc(100% - 20px);
  height: calc(100vh - 20px);
  overflow-y: scroll;
  // background-image: url("@/assets/people/bg.png");
  background-image: url("../../assets/people/bg.png");
  background-repeat: no-repeat;
  background-size: cover;
}

.content::-webkit-scrollbar {
  display: none;
}

.title-file {
  text-align: center;
  font-size: 22px;
  font-weight: 800;
  margin-bottom: 10px;
}

.up-title {
  font-weight: 800;
  margin-bottom: 10px;
  font-size: 16px;
}

.red {
  color: #ff0000;
}
</style>